import { totalCurrencies } from '@panel/commons/helpers/currenciesBySite';
import { site } from '@panel/commons/helpers';

const portalId = site.id;

const transformValue = value => {
  if (!value && value !== 0) return '';

  // Obtener el separador según el portal
  const separator = totalCurrencies.separators[portalId] || ',';

  // Convertir a string y remover caracteres no numéricos excepto el separador decimal
  const cleanValue = String(value).replace(/[^\d.,]/g, '');

  // Separar parte entera y decimal
  const parts = cleanValue.split(totalCurrencies.decimalSeparator[portalId] || '.');
  const integerPart = parts[0].replace(/[^\d]/g, '');

  // Aplicar separadores de miles
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator);

  // Si hay parte decimal, agregarla de vuelta
  if (parts.length > 1) {
    return `${formattedInteger}.${parts[1]}`;
  }

  return formattedInteger;
};

const formatNumberToInt = value => {
  if (value === null || value === undefined || value === '') return '';
  const cleanValue = String(value).replace(/[^\d]/g, '');
  return parseInt(cleanValue, 10);
};

export { transformValue, formatNumberToInt };
